import { SVG, SVGProps } from './svg'

export function IconShare(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M14 14c-5 0-9 2-10 5H3C3 13 8 8 14 8V5a1 1 0 0 1 1 0l6 6-6 6h-1v-3Z" />
    </SVG>
  )
}
